/**************************************************
 * Nombre:       Home_Programas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import TextoTitulo from "./SucComponentes/TextoTitulo";
import Tarjeta_Profundizaciones from "../../Tarjetas/Tarjeta_Profundizaciones";

const Home_Programas = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <TextoTitulo texto={'Programas'} titulo={'Técnicos, profundizaciones y convenios universitarios'}/>
                </Grid>



                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    sx={{mt: 6}}
                    spacing={4}
                >

                    {items.map((item, index) => (
                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Profundizaciones/>
                        </Grid>
                    ))}

                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Programas

const items = [1, 2, 3]